export const environmentSwitch = () => {
  window.salesforceUrl = 'https://megaport--partial.sandbox.my.salesforce.com/'
  if (location.hostname.includes('0.0.0.0') || location.hostname.includes('localhost') ) {
    window.envTitle = '[DEV] Forge'
  } else if (location.hostname.includes('qa')) {
    window.envTitle = '[QA] Forge'
  } else if (location.hostname.includes('uat')) {
    window.envTitle = '[UAT] Forge'
  } else if (location.host === 'forge.megaport.com') {
    window.envTitle = 'Forge'
    window.salesforceUrl = 'https://megaport.my.salesforce.com/'
  } else {
    window.envTitle = '[STAGING] Forge'
  }

  document.title = window.envTitle
}

export const setAppUrls = () => {
  let adminPortalUrl
  let cmaUrl
  let portalUrl

  // There is no per-env graph
  const graphUrl = 'https://graph.megaport.com'

  const regex = /forge-(.+?)\.megaport\.com/
  const match = location.host.match(regex)

  if (location.hostname.includes('0.0.0.0') || location.hostname.includes('localhost')) {
    // Case for local environment
    adminPortalUrl = 'https://admin-staging.megaport.com/#'
    cmaUrl = 'https://cma-staging.k.megaport.com'
    portalUrl = 'https://portal-staging.megaport.com'
  } else if (location.host === 'forge.megaport.com') {
    // Case for production
    adminPortalUrl = 'https://admin.megaport.com/#'
    cmaUrl = 'https://cma.megaport.com'
    portalUrl = 'https://portal.megaport.com'
  } else if (match) {
    // Case for any other environment
    adminPortalUrl = `https://admin-${match[1]}.megaport.com/#`
    cmaUrl = `https://cma-${match[1]}.k.megaport.com`
    portalUrl = `https://portal-${match[1]}.megaport.com`
  }

  window.adminPortalUrl = adminPortalUrl
  window.cmaUrl = cmaUrl
  window.portalUrl = portalUrl
  window.graphUrl = graphUrl
}
